import DefaultButton from "./ui/default-button.vue";

export default DefaultButton;
